/* eslint-disable dot-notation */
import React, { Fragment, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import {
  DatePicker, Dropdown, InputNumber, Select,
} from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import ReportActions from '@Actions/reportActions';
import Helpers from '@Apis/helpers';
import './style.scss';
import SelectDepartment from '@Components/Common/SelectDepartment';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import TenantSelector from '../../../Common/Selector/TenantSelector';
import DownloadReports from '../../ReportsHeader/DownloadReports';
import CategoryFilterNew from '../../../Common/CategoryFilterNew';
import PRZSelect from '../../../Common/UI/PRZSelect';

/**
 *
 */
function StockAgeingReportHeader({
  selectedTenant, department, user,
  setSelectedTenant, setDepartment, setCurrentPage, setSelectedDate, setSelectedMethod, setNoOfColumns, setIntervals, intervals, noOfColumns, selectedMethod, selectedDate,
  getDownloadReports, getDownloadReportsLoading, selectedDepartment, StockAgeingReportData, getStockAgeingReportsLoading, getStockAgeingReports, currentPage, limit, history, setSelectedCategory, selectedCategory,
}) {
  const [openPopover, setOpenPopover] = useState(false);
  const [selectedEmails, setSelectedEmails] = useState([user.username]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const pushParamsToUrl = (date, tenant, selectedDepartments, method, interval, steps, page, currentLimit, category) => {
    let url = 'stock_ageing_report?';
    if (date) url += `&date=${date}`;
    if (tenant) url += `&tenant_ids=${tenant}`;
    if (selectedDepartments) url += `&department_id=${selectedDepartments}`;
    if (method) url += `&method=${method}`;
    if (interval) url += `&interval=${interval}`;
    if (steps) url += `&steps=${steps}`;
    if (page) url += `&page=${page}`;
    if (currentLimit) url += `&limit=${currentLimit}`;
    if (category) url += `&category=${category}`;
    history.push(url);
  };

  function loadReportsDownloadData(operationType, required) {
    if (!getDownloadReportsLoading) {
      getDownloadReports('stock_ageing_report', '', '', (selectedTenant || user?.tenant_info?.tenant_id), '', '', operationType, '', '', department, '', '', selectedEmails.join(','), required, intervals, noOfColumns, selectedMethod, dayjs(selectedDate).format('YYYY-MM-DD'), '', '', selectedCategory);
      setOpenPopover(false);
    }
  }
  function applyFilters() {
    const Date = selectedDate ? dayjs(selectedDate).format('YYYY-MM-DD') : dayjs().subtract(1, 'month').format('YYYY-MM-DD');
    pushParamsToUrl(Date, selectedTenant, department, selectedMethod, intervals, noOfColumns, currentPage, limit, selectedCategory);
    getStockAgeingReports(selectedTenant, selectedMethod, intervals, noOfColumns, Date, department, currentPage, limit, selectedCategory);
    setIsDropdownVisible(false);
  }
  const priceOptions = [
    { label: 'Last Purchase Price', value: 'last_purchase_price' },
    { label: 'Cost Price', value: 'cost_price' },
    { label: 'Weighted Average Price', value: 'weighted_avg' },
  ];

  return (
    <Fragment>
      <div className="page-header__right report-header__wrapper" style={{ width: '100%', padding: '0px', paddingBottom: '1rem' }}>
        <div className="report-header__heading">
          Stock Ageing Report
        </div>
        <div className="report-header__action-container ageing-report__wrapper">
          { StockAgeingReportData?.length > 0
          && (
            <DownloadReports
              getDownloadReportsLoading={getDownloadReportsLoading}
              loadReportsDownloadData={(operationType, required) => loadReportsDownloadData(operationType, required)}
              selectedEmails={selectedEmails}
              selectedEmailsChange={(event) => setSelectedEmails(event)}
              user={user}
              openPopover={openPopover}
              openPopoverChange={() => setOpenPopover(!openPopover)}
            />
          )}
          <div className="report-header__date-picker">
            <Dropdown
              trigger={['click']}
              visible={isDropdownVisible}
              onVisibleChange={(visible) => setIsDropdownVisible(visible)}
              overlay={(
                <div className="header__filter__container">
                  <div className="filter__container filter__container-section">
                    <div className="filter__title">Costing Methods</div>
                    <PRZSelect
                      disabled={getStockAgeingReportsLoading}
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      value={selectedMethod}
                      onChange={(value) => setSelectedMethod(value)}
                      placeholder="Select Costing Method"
                      options={priceOptions} 
                    />
                  </div>
                  <div className="filter__container filter__container-section">
                    <div className="filter__title">As of</div>
                    <DatePicker
                      disabled={getStockAgeingReportsLoading}
                      value={selectedDate}
                      onChange={(date) => setSelectedDate(date)}
                      style={{ width: '100%' }}
                      format="YYYY-MM-DD"
                      placeholder="Select Date"
                    />

                  </div>
                  <div className="filter__container filter__container-section">
                    <div className="filter__title">Aging Intervals</div>
                    <InputNumber
                      value={noOfColumns}
                      onChange={(value) => setNoOfColumns(value)}
                      style={{ width: '100%' }}
                      min={5}
                      max={10}
                      disabled={getStockAgeingReportsLoading}
                    />
                  </div>
                  <div className="filter__container filter__container-section">
                    <div className="filter__title">Intervals of Days</div>
                    <InputNumber
                      value={intervals}
                      onChange={(value) => setIntervals(value)}
                      // parser={(value) => value.replace(' days', '')}
                      // formatter={(value) => `${value} days`}
                      min={15}
                      style={{ width: '100%' }}
                      disabled={getStockAgeingReportsLoading}
                    />
                  </div>
                  <div className="filter__container filter__container-section">
                    <H3Button
                      text="Apply"
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      customClass="organization-submit"
                      onClick={() => {
                        applyFilters();
                      }}
                      isLoading={getStockAgeingReportsLoading}
                      disabled={getStockAgeingReportsLoading}
                    />
                  </div>
                </div>
              )}
            >
              <div className="action-buttons">
                <div className="action-button">
                  {/* <H3Text text="Configuration" className="action-button-text" /> */}
                  <SettingOutlined />
                </div>
              </div>
            </Dropdown>
          </div>
          <React.Fragment>
            <div className="report-header__tenant-selector">
              <CategoryFilterNew
                onChange={(value) => {
                  setSelectedCategory(value);
                  // pushParamsToUrl(Date, selectedTenant, department, selectedMethod, intervals, noOfColumns, currentPage, limit, value);
                }}
                selectedCategory={selectedCategory}
                hideTitle
                style={{
                  borderRadius: '4px',
                  width: '150px',
                }}
                placeholder="Select category.."
              />
            </div>
          </React.Fragment>
          <React.Fragment>
            <div className="report-header__tenant-selector">
              <TenantSelector
                selectedTenant={selectedTenant}
                showSearch
                showAll={false}
                noDropdownAlign
                onChange={(value) => {
                  if (value === 'All') {
                    setCurrentPage(1);
                    setSelectedTenant(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVENTORY_INDENT, Helpers.permissionTypes.READ));
                  } else {
                    setCurrentPage(1);
                    setSelectedTenant(value);
                  }
                }}
                placeholder="Select Business Unit"
                inputClassName="orgInputContainer"
                customStyle={{
                  borderRadius: '4px',
                  width: '200px',
                  fontSize: '13px',
                  marginRight: '10px',
                  paddingTop: '2.5px',
                  marginBottom: '0px',
                }}
                hideTitle
                includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVENTORY_INDENT, Helpers.permissionTypes.READ)}
              />
            </div>
          </React.Fragment>
          <div className="report-header__dept-selector">
            <SelectDepartment
              title="Select Department"
              hideTitle
              selectedDepartment={department}
              noDropdownAlign
              onChange={(value) => {
                setDepartment(value?.department_id || '');
                setCurrentPage(1);
              }}
              customStyle={{
                borderRadius: '4px',
                width: '150px',
                fontSize: '13px',
                marginRight: '10px',
                paddingTop: '2.5px',
              }}
              disabled={false}
            />
          </div>

        </div>
      </div>
    </Fragment>
  );
}
const mapStateToProps = ({ ReportReducers, UserReducers }) => ({
  StockAgeingReportData: ReportReducers.StockAgeingReportData,
  user: UserReducers.user,
  getStockAgeingReportsLoading: ReportReducers.getStockAgeingReportsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getDownloadReports: (firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, fileReportType, reportName, sellerId, departmentId, moType, status, emails, noWait, intervals, noOfColumns, selectedMethod, selectedDate, costingMethod, customerId, category) => dispatch(
    ReportActions.getDownloadReports(firstSubUrl, secondSubUrl, orgId, tenantIds, fromDate, toDate, fileReportType, reportName, sellerId, departmentId, moType, status, emails, noWait, intervals, noOfColumns, selectedMethod, selectedDate, costingMethod, customerId, category),
  ),
  getStockAgeingReports: (tenantIds, method, interval, steps, date, departmentId, page, item, category) => dispatch(ReportActions.getStockAgeingReports(tenantIds, method, interval, steps, date, departmentId, page, item, category)),

});
StockAgeingReportHeader.propTypes = {
  setSelectedTenant: PropTypes.func,
  setDepartment: PropTypes.func,
  setCurrentPage: PropTypes.func,
  user: PropTypes.object,
  selectedTenant: PropTypes.any,
  department: PropTypes.any,
  getDownloadReportsLoading: PropTypes.bool,
  getDownloadReports: PropTypes.func,
  selectedDepartment: PropTypes.any,
  StockAgeingReportData: PropTypes.any,
  setSelectedDate: PropTypes.any,
  setSelectedMethod: PropTypes.any,
  setNoOfColumns: PropTypes.any,
  setIntervals: PropTypes.any,
  intervals: PropTypes.any,
  noOfColumns: PropTypes.any,
  selectedMethod: PropTypes.any,
  selectedDate: PropTypes.any,
  getStockAgeingReportsLoading: PropTypes.any,
  getStockAgeingReports: PropTypes.any,
  limit: PropTypes.any,
  currentPage: PropTypes.any,
  history: PropTypes.any,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StockAgeingReportHeader));
